// We use context (https://reactjs.org/docs/context.html) to share application state.
// This is a wrapper component that will be called in gatsby-browser.js and gatsby-ssr.js to wrap the whole app
import React from "react"
import { AppContext} from "./src/contexts"
import useAppState from "./src/states"

const Provider = props => {
	const state = useAppState()

	return (
		<AppContext.Provider value={state}>
			{props.children}
		</AppContext.Provider>
	)
}

export default ({ element }) => (
	<Provider>
		{element}
	</Provider>
)